import { defineStore } from "pinia";

export const useRecruitmentSourcingStore = defineStore('recruitmentSourcing', {
  state: () => ({
    recruitmentSourcing: {},
    recruitmentSourcings: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setRecruitmentSourcing(recruitmentSourcing) {
      this.recruitmentSourcing = recruitmentSourcing
    },
    setRecruitmentSourcings(recruitmentSourcings) {
      this.recruitmentSourcings = recruitmentSourcings
    },
    addRecruitmentSourcing(recruitmentSourcing) {
      this.recruitmentSourcings.unshift(recruitmentSourcing)
    },
    updateRecruitmentSourcing(recruitmentSourcing) {
      let index = this.recruitmentSourcings.findIndex(cl => cl.id === recruitmentSourcing.id)
      this.recruitmentSourcings.splice(index, 1, recruitmentSourcing)
    },
    deleteRecruitmentSourcing(recruitmentSourcing) {
      let index = this.recruitmentSourcings.findIndex(cl => cl.id === recruitmentSourcing.id)
      this.recruitmentSourcings.splice(index, 1)
    },
  },
});